import { apiRequest } from "./api";

export async function fetchActiveAnnouncements(position = "popup") {
  const payload = await apiRequest(`/api/v1/me/announcements?position=${position}`);
  return payload && Array.isArray(payload.announcements) ? payload.announcements : [];
}

export function markAnnouncementRead(announcementId) {
  return apiRequest(`/api/v1/me/announcements/${announcementId}/read`, { method: "POST", body: "{}" });
}

export async function fetchAdminAnnouncements(params = {}) {
  const search = new URLSearchParams();
  if (params.status) search.set("status", params.status);
  if (params.position) search.set("position", params.position);
  if (params.limit) search.set("limit", String(params.limit));
  if (params.offset) search.set("offset", String(params.offset));
  const suffix = search.toString() ? `?${search.toString()}` : "";
  return apiRequest(`/api/v1/admin/announcements${suffix}`);
}

export function upsertAnnouncement(data) {
  return apiRequest("/api/v1/admin/announcements", { method: "POST", body: JSON.stringify(data) });
}

export function deleteAnnouncement(announcementId) {
  return apiRequest(`/api/v1/admin/announcements/${announcementId}`, { method: "DELETE" });
}
